import Table from "react-bootstrap/Table";
import { Card, Spinner } from "react-bootstrap";
import DataFileReader from "../../../../../containers/onboarding/FileReader";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FileUploadHandler from "../../../../../containers/onboarding/FileUploadHandler";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../../store";

const UploadStudentsRosterManual = () => {
  const isLoading = useSelector<ApplicationState, boolean | undefined>(
      (s) => s.onboarding.isLoading.addStudents
    );
  const localFileDownload = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.location.href = "https://readycoach-bucket.s3.us-east-2.amazonaws.com/readycoach-bucket/system/sample_files/sample_roster.csv";
  }
  return (
    <>
       <h2 className="text-center font-weight-semibold mb-xl-3 mb-2">
        We can guide you in uploading data.
      </h2>
      <h4 className="text-center mb-2">
        To upload students from a roster file, it needs to be in a{" "}
        <a href="#" onClick={localFileDownload} className="link-offset-2 font-weight-bold cursor-pointer">CSV or XLSX format</a> 
        {" "} and include a header row. It must include at least three columns; Student ID, First Name and Last Name.
      </h4>
      <h4>
        <strong>Example format</strong>
      </h4>
      <Table className="uploadExampleTable">
        <thead>
          <tr>
            <th>Student ID</th>
            <th>First Name</th>
            <th>Last Name</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1001</td>
            <td>John</td>
            <td>Appleseed</td>
          </tr>
        </tbody>
      </Table>
      <p className="mb-1">In addition to matching the example format, please ensure your file does <b><u>not</u></b> contain any of the following:</p>
      <ul>
        <li>Duplicate Student IDs</li>
        <li>Blank Student IDs</li>
        <li>Student IDs containing characters other than letters and numbers</li>
        <li>Blank Student Names</li>
        <li>Student Names containing characters other than letters, numbers, spaces, hyphen (-), apostrophe ('), and comma (,)</li>
      </ul>
      <Card>
        <Card.Header>
          <FontAwesomeIcon icon="info-circle" /> Why do we need Student ID?
        </Card.Header>
        <Card.Body>
          <Card.Text className="smallerText">
            <>
              The Student ID should be unique for each student across in all
              files uploaded to ReadyCoach. This lets us match up student data
              without relying on their names.
            </>
          </Card.Text>
        </Card.Body>
      </Card>
      
      <h5 className="text-center font-weight-normal my-3">
        Click the button below to choose a student roster CSV or XLSX file from your computer to upload.
      </h5>
      <div className="text-center">
        <label className="blueBtnLg">
          UPLOAD ROSTER FILE{" "}
          {isLoading && <Spinner animation="border" size="sm" />}
          <FileUploadHandler />
          {/* <DataFileReader /> */}
        </label>
      </div>
    </>
  );
};

export default UploadStudentsRosterManual;
